import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=4eb075ac&scoped=true&"
import script from "./error-page.vue?vue&type=script&lang=ts&"
export * from "./error-page.vue?vue&type=script&lang=ts&"
import style0 from "./error-page.vue?vue&type=style&index=0&id=4eb075ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb075ac",
  null
  
)

export default component.exports